<template>
  <div>
    <div class="text-center">
      <AircapLogo class="mx-auto mb-8" size="50px" />
    </div>
    <div class="mb-10 text-2xl font-bold text-center">
      {{ title }}
    </div>
    <v-card
      v-for="(bankAccount, index) in bankAccounts"
      :key="index"
      class="p-5 border-theme"
      variant="flat"
      :class="{ 'mt-4': index }"
    >
      <div>
        <v-card-title v-if="bankAccount.name" class="text-base">{{
          bankAccount.name
        }}</v-card-title>
        <v-card-text v-if="bankAccount.iban">{{ bankAccount.iban }}</v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            variant="flat"
            color="success"
            block
            data-testid="bank-account-list-select-button"
            @click="$emit('select', bankAccount.id)"
          >
            {{ selectButtonText }}
          </v-btn>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import AircapLogo from "@/components/AircapLogo.vue";

defineProps<{
  title: string;
  selectButtonText: string;
  bankAccounts: Array<{
    id: string;
    name: string | undefined | null;
    iban: string | undefined | null;
  }>;
}>();

defineEmits<{
  select: [bankAccountId: string];
}>();
</script>
